import { performDraw, startSessionManager } from '@datadog/browser-core';
export var LOGS_SESSION_KEY = 'logs';
export var LoggerTrackingType;
(function (LoggerTrackingType) {
  LoggerTrackingType["NOT_TRACKED"] = "0";
  LoggerTrackingType["TRACKED"] = "1";
})(LoggerTrackingType || (LoggerTrackingType = {}));
export function startLogsSessionManager(configuration) {
  var sessionManager = startSessionManager(configuration.cookieOptions, LOGS_SESSION_KEY, function (rawTrackingType) {
    return computeSessionState(configuration, rawTrackingType);
  });
  return {
    findTrackedSession: function findTrackedSession(startTime) {
      var session = sessionManager.findActiveSession(startTime);
      return session && session.trackingType === LoggerTrackingType.TRACKED ? {
        id: session.id
      } : undefined;
    }
  };
}
export function startLogsSessionManagerStub(configuration) {
  var isTracked = computeTrackingType(configuration) === LoggerTrackingType.TRACKED;
  var session = isTracked ? {} : undefined;
  return {
    findTrackedSession: function findTrackedSession() {
      return session;
    }
  };
}
function computeTrackingType(configuration) {
  if (!performDraw(configuration.sampleRate)) {
    return LoggerTrackingType.NOT_TRACKED;
  }
  return LoggerTrackingType.TRACKED;
}
function computeSessionState(configuration, rawSessionType) {
  var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
  return {
    trackingType: trackingType,
    isTracked: trackingType === LoggerTrackingType.TRACKED
  };
}
function hasValidLoggerSession(trackingType) {
  return trackingType === LoggerTrackingType.NOT_TRACKED || trackingType === LoggerTrackingType.TRACKED;
}